import { motion } from 'motion/react';
import { useAppColors } from '@/src/lib/theme';
import LogoMark from '@/src/components/LogoMark';

export default function TypingDots() {
  const c = useAppColors();

  return (
    <div className="flex items-end gap-2" id="typing-indicator">
      <div
        className="w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0"
        style={{ background: c.iconBg }}
      >
        <motion.div
          animate={{ rotate: 360 }}
          transition={{ duration: 1.8, repeat: Infinity, ease: 'linear' }}
          className="flex items-center justify-center"
        >
          <LogoMark size={45} color={c.text} />
        </motion.div>
      </div>

      <div
        className="flex gap-1.5 items-center h-8 px-4 py-3 rounded-2xl w-fit"
        style={{ background: c.bgElevated, border: `1px solid ${c.border}` }}
      >
        {[0, 1, 2].map((i) => (
          <motion.div
            key={i}
            animate={{ opacity: [0.3, 1, 0.3] }}
            transition={{
              duration: 1,
              repeat: Infinity,
              delay: i * 0.15,
              ease: 'easeInOut',
            }}
            className="w-1.5 h-1.5 rounded-full"
            style={{ background: c.textDim }}
          />
        ))}
      </div>
    </div>
  );
}